// todo move this shit to webpack...

document.getElementById('welcome-typed-text2').classList.add('d-none');
new Typed('#welcome-typed', {
    stringsElement: '#welcome-typed-text',
    typeSpeed: 50,
    showCursor: false,
    onComplete: () => {
        new Typed('#welcome-typed2', {
            stringsElement: '#welcome-typed-text2',
            typeSpeed: 35,
            showCursor: false,
        });
    },
});

document.querySelectorAll('.nav-link').forEach(function (el) {
    el.addEventListener('click', function (e) {
        let url = new URL(e.target.href);
        if (url.hash) {
            const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvasMenu');
            bsOffcanvas.hide();
        }
    });
});
